import styled from "styled-components";

export interface IconContainerProps {
  marginTop?: "none" | "medium";
}

export const IconContainer = styled.div<IconContainerProps>`
  display: flex;
  align-self: flex-start;
  justify-content: flex-start;
  cursor: pointer;
  z-index: 999;
  margin-top: ${({ marginTop = "medium" }) =>
    marginTop === "medium" ? 16 : 0}px;
  padding: 0;
`;
